import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["aria-label", "className", "fwdRef", "size", "style"];
import React, { forwardRef } from 'react';
import { buildVersionedClassNames } from '@op/opds.opux-utilities';
/**
 * _An animated success feedback graphic._
 *
 * ***
 *
 * Animated checkmark icon, used e.g. on last pages of purchase paths to indicate
 * success. Has a prop to control its size. Additional props (including `ref`)
 * will be forwarded to the `<svg>` element.
 */
export const AnimCheck = _ref => {
  let {
      'aria-label': label,
      className,
      fwdRef,
      size,
      style
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": !label,
    "aria-label": label,
    role: "img"
  }, props, {
    className: buildVersionedClassNames('ds-anim-check', className),
    ref: fwdRef,
    style: _extends({}, style, {
      height: size,
      width: size
    }),
    viewBox: "-48 -48 96 96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "0",
    cy: "0",
    r: "46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16 -2l14 15L20 -14"
  }));
};
const Fwd = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(AnimCheck, _extends({}, props, {
  fwdRef: ref
})));
Fwd.displayName = 'AnimCheck';
export default Fwd;